import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Stack, Typography } from '@mui/material'
import version from '../generated/version.json'

export function AppFooter(): ReactElement {
    const { t } = useTranslation()
    return (
        <Stack direction="row" justifyContent="center" position="fixed" bottom={0} left={0} right={0}>
            <Typography variant="body2" bgcolor="offWhite.main" px={0.5}>
                {t('version', version)}
            </Typography>
        </Stack>
    )
}
